import { DataLayer } from '@grandvisionhq/analytics';

const pushVirtualMirrorDataLayerEvent = ({ event , interactionType , siteFeature ='vto_flow'  })=>{
    if (!event) {
        console.warn(`cannot send event '${event}', key does not exist`);
        return;
    }
    const eventData = {
        event,
        interaction_type: interactionType,
        site_feature: siteFeature
    };
    DataLayer.pushEvent(eventData);
};

export { pushVirtualMirrorDataLayerEvent };
//# sourceMappingURL=events.js.map
